/**
 * @desc 根据categoryNameCns查询品类NoFull
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<Array<defs.basics.ProductCategroyResponseDtoRpc>>;
export function request(body: Array<string>, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/productCategroy/getFullByCategoryNameCns`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
